import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectors as memberSelectors } from 'member-reducer'
import { TermsAndConditionsStep } from 'member-portal/components'
import { AccountType, MembershipType } from 'types'
import { makeMemberApplicationApplyPath, PATH } from 'config'
import { useReferralEnabled } from 'utils'

const propTypes = {
  account: AccountType.isRequired,
  membership: MembershipType.isRequired,
}

function NewMemberTermsAndConditions({ account, membership }) {
  const isReferralEnabled = useReferralEnabled()

  return (
    <TermsAndConditionsStep
      account={account}
      membership={membership}
      basePath={makeMemberApplicationApplyPath(PATH.TERMS_AND_CONDITIONS)}
      nextStep={makeMemberApplicationApplyPath(PATH.PAYMENT)}
      showReferral={isReferralEnabled}
    />
  )
}

NewMemberTermsAndConditions.propTypes = propTypes

function mapStateToProps(state) {
  return {
    account: memberSelectors.account(state),
    membership: memberSelectors.membership(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  NewMemberTermsAndConditions,
)
